'use client';

import { ActiveDevicesSection } from '../../components/UserProfile/ActiveDevicesSection';
import { createSection } from '../createSection';

export const UserProfileActiveDevicesSection = createSection('UserProfileActiveDevicesSection', ActiveDevicesSection);
